import apiClient from './apiClient'
export {
  searchProjectList,
  getCommunityListByCompanyId,
  getStyleFilter,
  getDistrictFilter
}

// 获取小区列表
async function getCommunityListByCompanyId({
  companyId,
  isSearchFollow = false,
  showPublicOnly = true,
  showProject
}) {
  if (!companyId || companyId === 'undefined') return { data: { data: [] } }
  const res = await apiClient.get('getCommunityListByCompanyId.do', {
    params: {
      companyId,
      isSearchFollow,
      showPublicOnly,
      showProject
    }
  })
  return res.data
}

async function getStyleFilter({ companyId, isDisplay = 1 }) {
  const res = await apiClient.get('getStyleFilter.do', {
    params: { companyId, isDisplay }
  })
  return res.data
}
async function getDistrictFilter({ companyId }) {
  const res = await apiClient.get('getDistrictFilter.do', {
    params: { companyId }
  })
  return res.data
}

async function searchProjectList({
  pageNo = 1,
  pageSize = 10,
  latitude = 31.25956,
  longititude = 121.52609,
  district = '',
  region = '',
  style = '',
  stage = '',
  room = '',
  sort = 1,
  personId = 0,
  companyId = 0,
  isdisplay = '',
  showProject = 'all'
}) {
  const res = await apiClient.get('searchProjectList.do', {
    params: {
      pageNo,
      pageSize,
      latitude,
      longititude,
      district,
      region,
      style,
      stage,
      sort,
      room,
      personId,
      companyId,
      isdisplay,
      showProject
    }
  })
  return res.data
}

export async function getCommunityDistributionByCompanyId(
  companyId,
  showProject
) {
  const res = await apiClient.post('statistics/map/site', {
    companyId,
    showProject
  })
  return res.data
}

export async function getShowProjectOptions(companyId) {
  const res = await apiClient.post(
    'statistics/map/options',
    {
      companyId
    },
    { baseURL: process.env.YQZ_CAMERA_API }
  )

  return res.data
}
